import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private authenticationUserSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public authenticationUser$: Observable<boolean> = this.authenticationUserSubject.asObservable();

  private selectedCountrySubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  public selectedCountry$: Observable<string | null> = this.selectedCountrySubject.asObservable();

  constructor() {
    if (typeof window !== "undefined") {
        const storedAuthStatus = localStorage.getItem('authStatus');
    if (storedAuthStatus !== null) {
      const authStatus = JSON.parse(storedAuthStatus);
      this.authenticationUserSubject.next(authStatus);
    }

    const storedCountry = localStorage.getItem('selectedCountry');
    if (storedCountry !== null) {
      this.selectedCountrySubject.next(storedCountry);
    }
    }
    
  }

  getAuthentication(): boolean {
    return this.authenticationUserSubject.value;
  }

  setAuthentication(user: boolean): Observable<boolean> {
    this.authenticationUserSubject.next(user);
    localStorage.setItem('authStatus', JSON.stringify(user));
    return this.authenticationUser$; // Return Observable to track completion
  }

  getSelectedCountry(): string | null {
    return this.selectedCountrySubject.value;
  }

  setSelectedCountry(country: string | null): Observable<string | null> {
    this.selectedCountrySubject.next(country);
    if (country !== null) {
      localStorage.setItem('selectedCountry', country);
    } else {
      localStorage.removeItem('selectedCountry');
    }
    return this.selectedCountry$; // Return Observable to track completion
  }
}
